import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { FaCheck } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllTaskDetailsByloginId, getTaskDataProjectWiseData, getEmpTaskCountList } from '../../Redux/Task/Action';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getLeaveBalanceList } from "../../Redux/Leave/Action";
import { getAlerts, alertCompleted } from '../../Redux/Alert/Action';
import { getEmployeeData } from '../../Redux/NewHire/Action';
import Swal from "sweetalert2";
import { format } from 'date-fns';
// import { newDate } from 'react-datepicker/dist/date_utils';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

function parseDDMMYYYY(dateStr) {
    if (typeof dateStr !== "string") return null;
    const parts = dateStr.split("-");
    if (parts.length !== 3) return null;

    const [day, month, year] = parts.map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;

    return new Date(year, month - 1, day); // JS months are 0-indexed
}

function stripTime(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}


const AdminDash = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { allTaskDetails, projectWiseData, empTaskContList } = useSelector((store) => store.task);
    const { alerts } = useSelector((state) => state.alert);
    const { employeeData } = useSelector((store) => store.newHireData);

    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const role = localStorage.getItem("role");

    const [statusCounts, setStatusCounts] = useState({});

    const loadDashBoard = (token, loginId) => {
        dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
        dispatch(getAlerts(loginId, token));
        dispatch(getAllTaskDetailsByloginId("0", token));
        dispatch(getEmployeeData(token))
        dispatch(getTaskDataProjectWiseData(token))
        dispatch(getEmpTaskCountList(token))
    }

    useEffect(() => {
        loadDashBoard(token, loginId);
    }, [token, loginId]);

    useEffect(() => {
        if (allTaskDetails?.taskMaster?.length > 0) {
            const counts = allTaskDetails.taskMaster.reduce((acc, task) => {
                const status = task.status || "Unknown";
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});
            setStatusCounts(counts);
        } else {
            setStatusCounts({});
        }
    }, [allTaskDetails]);


    const statutoryList = alerts?.alertDto?.filter(item => item.type === 'S') || [];
    const dailyList = alerts?.alertDto?.filter(item => item.type === 'D') || [];


    const STATUS_ORDER = [
        "To Do",
        "In Progress",
        "In Testing",
        "Rejected",
        "Reopened",
        "Done",
        "Unknown",
    ];

    const STATUS_COLOR_MAP = {
        "To Do": "#42a5f5",
        "In Progress": "#aebb66ff",
        "In Testing": "#ffca28",
        "Rejected": "#ef5350",
        "Reopened": "#ab47bc",
        "Done": "#2a962fff",
        "Unknown": "#8d6e63",
    };

    //  Build labels, values, and colors arrays in the fixed order
    const labels = [];
    const dataValues = [];
    const colors = [];

    STATUS_ORDER.forEach((statusKey) => {
        const count = statusCounts[statusKey] || 0;
        if (count > 0) {
            labels.push(statusKey);
            dataValues.push(count);
            colors.push(STATUS_COLOR_MAP[statusKey] || "#8d6e63");
        }
    });

    //  Prepare your chart dataset using those arrays
    const taksDataforChart = {
        labels,
        datasets: [
            {
                label: "Task Status Count",
                data: dataValues,
                backgroundColor: colors,
                borderColor: "#ffffff",
                borderWidth: 2,
            },
        ],
    };

    // Chart options (same as before)
    const dashOptionsforChart = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    color: "#333",
                    boxWidth: 10, // default is 40 → make smaller
                    boxHeight: 10,
                    padding: 12,

                    font: { size: 13, weight: "500" },
                },
            },
            datalabels: {
                color: "#fff",
                font: { weight: "bold", size: 14 },
                formatter: (value) => value,
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.label}: ${context.formattedValue}`,
                },
            },
        },
    };



    const handleCompletd = async (item) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            html: `Do you want to complete the work?<br><strong>"${item.subject}"</strong>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        })

        if (result.isConfirmed) {
            Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            dispatch(alertCompleted(token, item.alertId))
                .then((response) => {
                    if (response.statusMessage === "SUCCESS") {
                        dispatch(getAlerts(loginId, token));
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.statusDesc,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error updating the alert",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    }

    const isDatePast = (dateStr) => {
        if (!dateStr) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const [day, month, year] = dateStr.split("-");
        const endDate = new Date(year, month - 1, day);
        endDate.setHours(0, 0, 0, 0);
        return endDate < today;
    };

    const navigateOptions = {
        "Office": "/employee",
        "Support": "/supportEmployee",
        "Contract": "/contractEmployee"
    }

    const today = stripTime(new Date());
    const fiveDaysAhead = new Date(today);
    fiveDaysAhead.setDate(today.getDate() + 3);

    const filteredStatutoryList = statutoryList.filter(s => {
        if (!s.date) return false; // skip missing dates
        const backendDate = parseDDMMYYYY(s.date.trim());
        if (!(backendDate instanceof Date) || isNaN(backendDate)) return false;

        const backendDateNoTime = stripTime(backendDate);
        return backendDateNoTime >= today && backendDateNoTime <= fiveDaysAhead;
    });



    return (
        <div>

            <div className="row">
                <div className="col-md-3 mb-4">
                    <div className="card shadow-sm rounded-4">
                        <div className="card-body">

                            <h6 className="text-center mb-4 w-100 fw-bold">Employee Data</h6>

                            <div className="d-flex flex-wrap justify-content-center gap-3">

                                {employeeData?.countByDesignationName &&
                                    Object.entries(employeeData.countByDesignationName)
                                        .filter(([key]) => key !== "HR" && key !== "Super Admin")
                                        .map(([designation, count]) => (
                                            <div
                                                key={designation}
                                                className="role-box"
                                                onClick={() => navigate(navigateOptions[designation])}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div className="role-badge">{count ?? 0}</div>
                                                <div className="role-name">{designation || "-"}</div>
                                            </div>
                                        ))
                                }


                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-md-9 mb-4">
                    <div className="card shadow-sm rounded-4">
                        <div className="card-body">
                            <h6 className="text-center mb-4 w-100 fw-bold">Pending Task Counts Employee Wise As on {format(new Date(), 'dd-MMM-yyyy')}</h6>
                            <div className="project-scroll-container">
                                {empTaskContList?.empTaskCountDTOList?.map(({ firstName, taskCount, loginId }) => {
                                    return (
                                        <div className="project-card" key={loginId}>
                                            <div className="project-count-circle">{taskCount ?? 0}</div>
                                            <div className="project-name">{firstName || "-"}</div>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className='row'>
                <div className="col-md-8 mb-4">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="card shadow-sm rounded-4" style={{ minHeight: "409px" }}>
                                <div className="card-body">

                                    <div className="row">
                                        {/* LEFT: Chart */}
                                        <div className="col-md-3 d-flex flex-column justify-content-center align-items-center">

                                            <h6 className="text-center mb-3 w-100 fw-bold">Task Status Overview</h6>

                                            <div
                                                style={{
                                                    width: "111%",
                                                    height: 280,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {labels.length > 0 ? (
                                                    <Pie data={taksDataforChart} options={dashOptionsforChart} />
                                                ) : (
                                                    <p className="text-center text-muted">No data available</p>
                                                )}
                                            </div>

                                        </div>

                                        {/* RIGHT: Task List */}
                                        <div className="col-md-9">

                                            <h6 className="text-center mb-1 fw-bold">Task Details</h6>

                                            {/* Legend */}
                                            {/* <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                gap: '12px',
                                marginTop: '10px',
                            }}
                        >
                            {Object.entries(STATUS_COLOR_MAP)
                                .filter(([status]) => status !== "Unknown" && status !== "Done")
                                .map(([status, color]) => (
                                    <div key={status} style={{ display: 'flex', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                width: '14px',
                                                height: '14px',
                                                backgroundColor: color,
                                                borderRadius: '3px',
                                                marginRight: '6px',
                                                border: '1px solid #ccc',
                                            }}
                                        ></div>
                                        <span style={{ fontWeight: 500, fontSize: '0.9rem' }}>{status}</span>
                                    </div>
                                ))}
                        </div> */}

                                            {/* Table */}
                                            <div
                                                style={{
                                                    flex: 1,
                                                    overflowY: "auto",
                                                    maxHeight: "300px",
                                                }}
                                            >
                                                {allTaskDetails?.taskMaster && allTaskDetails.taskMaster.length > 0 ? (
                                                    <table className="table table-sm table-hover align-middle mb-0">
                                                        <thead className="table-light sticky-header">
                                                            <tr>
                                                                <th>Task No</th>
                                                                <th>Employee</th>
                                                                <th>Title</th>
                                                                <th>PDC</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {allTaskDetails.taskMaster
                                                                .filter(task => task.status !== "Done")
                                                                .map((task, index) => (
                                                                    <tr key={task.id || index}>
                                                                        <td
                                                                            style={{
                                                                                fontWeight: '500',
                                                                                color: STATUS_COLOR_MAP[task.status] || STATUS_COLOR_MAP["Unknown"],
                                                                            }}
                                                                        >
                                                                            {task.taskNo || '-'}
                                                                        </td>

                                                                        <td>{task.assignName || '-'}</td>
                                                                        <td className="text-start">{task.title || '-'}</td>
                                                                        <td
                                                                            className={`fw-medium ${isDatePast(task.endDate) ? 'text-danger' : ''}`}
                                                                        >
                                                                            {task.endDate || '-'}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <p className="text-center text-muted mt-3">No tasks available</p>
                                                )}
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className='col-md-4'>
                    <div className="row">
                        <div className="col-md-6">
                            <div
                                className="card shadow-sm h-100 rounded-4"
                            >
                                <div
                                    className="card-header text-center fw-semibold text-dark rounded-top-4"
                                    style={{
                                        background: "linear-gradient(90deg, rgb(201 122 227), rgb(155 227 249))",
                                        fontSize: "1.1rem",
                                        padding: "10px 0",
                                        letterSpacing: "0.5px",
                                    }}
                                >
                                    <i className="bi bi-file-earmark-text me-2 text-info"></i>
                                    Statutory Alert
                                </div>

                                <div className="card-body p-3" style={{ minHeight: "355px" }}>
                                    {filteredStatutoryList && filteredStatutoryList.length > 0 ? (
                                        <ul
                                            className="list-group list-group-flush custom-scroll"
                                            style={{ maxHeight: "327px", overflowY: "auto" }}
                                        >
                                            {filteredStatutoryList
                                                .map((item, index) => (
                                                    <li
                                                        key={index}
                                                        className="list-group-item d-flex justify-content-between align-items-center border-0 border-bottom"
                                                        style={{
                                                            fontSize: "14px",
                                                            backgroundColor: "transparent",
                                                            transition: "all 0.3s ease",
                                                        }}
                                                        onMouseEnter={(e) =>
                                                            (e.currentTarget.style.backgroundColor = "#d7e0fdff")
                                                        }
                                                        onMouseLeave={(e) =>
                                                            (e.currentTarget.style.backgroundColor = "transparent")
                                                        }
                                                    >
                                                        {/* Left side - text info */}
                                                        <div className="d-flex flex-column text-start">
                                                            <span className="fw-medium text-secondary">
                                                                {item?.subject ?? "-"}
                                                            </span>
                                                            <small className="text-muted">
                                                                <i className="bi bi-calendar-event me-1"></i>
                                                                {item?.date ?? "-"}
                                                            </small>
                                                        </div>

                                                        {/* Right side - button */}
                                                        {(() => {
                                                            const [day, month, year] = item?.date?.split("-");
                                                            const itemDate = new Date(`${year}-${month}-${day}`);
                                                            const today = new Date();

                                                            // Normalize both (ignore time)
                                                            itemDate.setHours(0, 0, 0, 0);
                                                            today.setHours(0, 0, 0, 0);

                                                            // Calculate 3 days before the item date
                                                            const threeDaysBefore = new Date(itemDate);
                                                            threeDaysBefore.setDate(itemDate.getDate() - 3);

                                                            // Button visible if:
                                                            // - Today >= 3 days before item date (window opens)
                                                            // - AND (task not completed yet)
                                                            const isWithinWindow = today >= threeDaysBefore || today > itemDate;

                                                            return (
                                                                isWithinWindow && (
                                                                    <button
                                                                        className="btn btn-primary btn-sm rounded-5 smallButton"
                                                                        // style={{ height: "25px", fontSize: "11px" }}
                                                                        onClick={() => handleCompletd(item)}
                                                                    >
                                                                        <FaCheck />
                                                                    </button>
                                                                )
                                                            );
                                                        })()}

                                                    </li>
                                                ))}
                                        </ul>

                                    ) : (
                                        <div className="d-flex flex-column align-items-center justify-content-center text-muted" style={{ height: "100%" }}>
                                            <i className="bi bi-inbox fs-2 mb-2 text-secondary"></i>
                                            <span>No data available</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div
                                className="card shadow-sm h-100 rounded-4"
                            >
                                <div
                                    className="card-header text-center fw-semibold text-dark rounded-top-4"
                                    style={{
                                        background: "linear-gradient(90deg, rgb(184 241 148), rgb(129 210 249))",
                                        fontSize: "1.1rem",
                                        padding: "10px 0",
                                        letterSpacing: "0.5px",
                                    }}
                                >
                                    <i className="bi bi-file-earmark-text me-2 text-info"></i>
                                    Daily Alert
                                </div>

                                <div className="card-body p-3" style={{ minHeight: "355px" }}>
                                    {dailyList && dailyList.length > 0 ? (
                                        <ul
                                            className="list-group list-group-flush custom-scroll"
                                            style={{ maxHeight: "327px", overflowY: "auto" }}
                                        >
                                            {dailyList.map((item, index) => (
                                                <li
                                                    key={index}
                                                    className="list-group-item d-flex justify-content-between align-items-center border-0 border-bottom"
                                                    style={{
                                                        fontSize: "14px",
                                                        backgroundColor: "transparent",
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) =>
                                                        (e.currentTarget.style.backgroundColor = "#d7fdeaff")
                                                    }
                                                    onMouseLeave={(e) =>
                                                        (e.currentTarget.style.backgroundColor = "transparent")
                                                    }
                                                >
                                                    {/* Left side - text info */}
                                                    <div className="d-flex flex-column text-start">
                                                        <span className="fw-medium text-secondary">{item?.subject ?? "-"}</span>
                                                        <small className="text-muted">
                                                            <i className="bi bi-calendar-event me-1"></i>
                                                            {item?.date ?? "-"}
                                                        </small>
                                                    </div>

                                                    {/* Right side - button */}
                                                    {(() => {
                                                        const [day, month, year] = item?.date?.split("-");
                                                        const itemDate = new Date(`${year}-${month}-${day}`);
                                                        const today = new Date();

                                                        // Normalize both (ignore time)
                                                        itemDate.setHours(0, 0, 0, 0);
                                                        today.setHours(0, 0, 0, 0);

                                                        // Calculate 3 days before the item date
                                                        const threeDaysBefore = new Date(itemDate);
                                                        threeDaysBefore.setDate(itemDate.getDate() - 3);

                                                        // Button visible if:
                                                        // - Today >= 3 days before item date (window opens)
                                                        // - AND (task not completed yet)
                                                        const isWithinWindow = today >= threeDaysBefore || today > itemDate;

                                                        return (
                                                            isWithinWindow && (
                                                                <button
                                                                    className="btn btn-primary btn-sm rounded-5 smallButton"
                                                                    // style={{ height: "25px", fontSize: "11px" }}
                                                                    onClick={() => handleCompletd(item)}
                                                                >
                                                                    <FaCheck />
                                                                </button>

                                                            )
                                                        );
                                                    })()}

                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <div className="d-flex flex-column align-items-center justify-content-center text-muted" style={{ height: "100%" }}>
                                            <i className="bi bi-inbox fs-2 mb-2 text-secondary"></i>
                                            <span>No data available</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdminDash;